const handleOpenModal = (ident) => {
	const event = new CustomEvent(ident);
	window.dispatchEvent(event);
};

const handleCloseModal = (ident) => {
	const event = new CustomEvent(ident);
	window.dispatchEvent(event);
};

export { handleOpenModal, handleCloseModal };
